export default __webpack_public_path__ + "static/media/background.a27108fc.png";